/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SwitchField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getManifest, listManifestItems } from "../graphql/queries";
import { updateManifest, updateManifestItem } from "../graphql/mutations";
import { useNavigate, useLocation } from 'react-router-dom'
const client = generateClient();

export default function ManifestUpdateForm(props) {
  const storedGroups = JSON.parse(localStorage.getItem('loggedInUserGroups') || '[]');

  const location = useLocation();
  const navigate = useNavigate()
  let userId = location.state.userId;
  const {
    id: userIds,
    manifest: manifestModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    title: "",
    carrierId: "",
    adminApproved: false,
    carrierApproved: false,
    adminComments: "",
    carrierComments: "",
    manifestDate: "",
    contentStartDate: "",
    contentEndDate: "",
    isActive: false,
    isManifestDeployed: false,
    DeploymentDate: "",
    bucket: "",
    date: "",
    ManifestItems: [],
  };
  const [title, setTitle] = React.useState(initialValues.title);
  const [carrierId, setCarrierId] = React.useState(initialValues.carrierId);
  const [adminApproved, setAdminApproved] = React.useState(
    initialValues.adminApproved
  );
  const [carrierApproved, setCarrierApproved] = React.useState(
    initialValues.carrierApproved
  );
  const [manifestItem, setManifestItem] = React.useState(false);

  const [adminComments, setAdminComments] = React.useState(
    initialValues.adminComments
  );
  const [carrierComments, setCarrierComments] = React.useState(
    initialValues.carrierComments
  );
  const [manifestDate, setManifestDate] = React.useState(
    initialValues.manifestDate
  );
  const [contentStartDate, setContentStartDate] = React.useState(
    initialValues.contentStartDate
  );
  const [contentEndDate, setContentEndDate] = React.useState(
    initialValues.contentEndDate
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [isManifestDeployed, setIsManifestDeployed] = React.useState(
    initialValues.isManifestDeployed
  );
  const [DeploymentDate, setDeploymentDate] = React.useState(
    initialValues.DeploymentDate
  );
  const [bucket, setBucket] = React.useState(initialValues.bucket);
  const [date, setDate] = React.useState(initialValues.date);
  const [ManifestItems, setManifestItems] = React.useState(
    initialValues.ManifestItems
  );
  const [ManifestItemsLoading, setManifestItemsLoading] = React.useState(false);
  const [manifestItemsRecords, setManifestItemsRecords] = React.useState([]);
  const autocompleteLength = 10;
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = manifestRecord
      ? {
        ...initialValues,
        ...manifestRecord,
        ManifestItems: linkedManifestItems,
      }
      : initialValues;
    setTitle(cleanValues.title);
    setCarrierId(cleanValues.carrierId);
    setAdminApproved(cleanValues.adminApproved);
    setCarrierApproved(cleanValues.carrierApproved);
    setAdminComments(cleanValues.adminComments);
    setCarrierComments(cleanValues.carrierComments);
    setManifestDate(cleanValues.manifestDate);
    setContentStartDate(cleanValues.contentStartDate);
    setContentEndDate(cleanValues.contentEndDate);
    setIsActive(cleanValues.isActive);
    setIsManifestDeployed(cleanValues.isManifestDeployed);
    setDeploymentDate(cleanValues.DeploymentDate);
    setBucket(cleanValues.bucket);
    setDate(cleanValues.date);
    setManifestItems(cleanValues.ManifestItems ?? []);
    setCurrentManifestItemsValue(undefined);
    setCurrentManifestItemsDisplayValue("");
    setErrors({});
  };
  const [manifestRecord, setManifestRecord] = React.useState(manifestModelProp);
  const [linkedManifestItems, setLinkedManifestItems] = React.useState([]);
  const canUnlinkManifestItems = false;
  const manifestItemList = async () => {
    const response = await client.graphql({
      query: listManifestItems,
    });

    const items = response.data.listManifestItems.items
      .filter(item => item.manifestID === userId);
    setManifestItem(items.length > 0)
  }

  React.useEffect(() => {
    manifestItemList()
    const queryData = async () => {
      const record = userId
        ? (
          await client.graphql({
            query: getManifest.replaceAll("__typename", ""),
            variables: { id: userId },
          })
        )?.data?.getManifest
        : manifestModelProp;
      const linkedManifestItems = record?.ManifestItems?.items ?? [];
      setLinkedManifestItems(linkedManifestItems);
      setManifestRecord(record);
    };
    queryData();
  }, [userId, manifestModelProp]);
  React.useEffect(resetStateValues, [manifestRecord, linkedManifestItems]);
  const [
    currentManifestItemsDisplayValue,
    setCurrentManifestItemsDisplayValue,
  ] = React.useState("");
  const [currentManifestItemsValue, setCurrentManifestItemsValue] =
    React.useState(undefined);
  const ManifestItemsRef = React.createRef();
  const getIDValue = {
    ManifestItems: (r) => JSON.stringify({ id: r?.id }),
  };
  const ManifestItemsIdSet = new Set(
    Array.isArray(ManifestItems)
      ? ManifestItems.map((r) => getIDValue.ManifestItems?.(r))
      : getIDValue.ManifestItems?.(ManifestItems)
  );
  const getDisplayValue = {
    ManifestItems: (r) =>
      `${r?.providerId ? r?.providerId + " - " : ""}${r?.id}`,
  };
  const validations = {
    title: [],
    carrierId: [{ type: "Required" }],
    adminApproved: [{ type: "Required" }],
    carrierApproved: [{ type: "Required" }],
    adminComments: [],
    carrierComments: [],
    manifestDate: [],
    contentStartDate: [],
    contentEndDate: [],
    isActive: [],
    isManifestDeployed: [],
    DeploymentDate: [],
    bucket: [],
    date: [],
    ManifestItems: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const convertToLocal = (date) => {
    const df = new Intl.DateTimeFormat("default", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      calendar: "iso8601",
      numberingSystem: "latn",
      hourCycle: "h23",
    });
    const parts = df.formatToParts(date).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
  };
  const fetchManifestItemsRecords = async (value) => {
    setManifestItemsLoading(true);
    const newOptions = [];
    let newNext = "";
    while (newOptions.length < autocompleteLength && newNext != null) {
      const variables = {
        limit: autocompleteLength * 5,
        filter: {
          or: [
            { providerId: { contains: value } },
            { id: { contains: value } },
          ],
        },
      };
      if (newNext) {
        variables["nextToken"] = newNext;
      }
      const result = (
        await client.graphql({
          query: listManifestItems.replaceAll("__typename", ""),
          variables,
        })
      )?.data?.listManifestItems?.items;
      var loaded = result.filter(
        (item) => !ManifestItemsIdSet.has(getIDValue.ManifestItems?.(item))
      );
      newOptions.push(...loaded);
      newNext = result.nextToken;
    }
    setManifestItemsRecords(newOptions.slice(0, autocompleteLength));
    setManifestItemsLoading(false);
  };
  React.useEffect(() => {
    fetchManifestItemsRecords("");
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          title: title ?? null,
          carrierId,
          adminApproved,
          carrierApproved,
          adminComments: adminComments ?? null,
          carrierComments: carrierComments ?? null,
          manifestDate: manifestDate ?? null,
          contentStartDate: contentStartDate ?? null,
          contentEndDate: contentEndDate ?? null,
          isActive: isActive ?? null,
          isManifestDeployed: isManifestDeployed ?? null,
          DeploymentDate: DeploymentDate ?? null,
          bucket: bucket ?? null,
          date: date ?? null,
          ManifestItems: ManifestItems ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(
                    fieldName,
                    item,
                    getDisplayValue[fieldName]
                  )
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(
                fieldName,
                modelFields[fieldName],
                getDisplayValue[fieldName]
              )
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const promises = [];
          const manifestItemsToLink = [];
          const manifestItemsToUnLink = [];
          const manifestItemsSet = new Set();
          const linkedManifestItemsSet = new Set();
          ManifestItems.forEach((r) =>
            manifestItemsSet.add(getIDValue.ManifestItems?.(r))
          );
          linkedManifestItems.forEach((r) =>
            linkedManifestItemsSet.add(getIDValue.ManifestItems?.(r))
          );
          linkedManifestItems.forEach((r) => {
            if (!manifestItemsSet.has(getIDValue.ManifestItems?.(r))) {
              manifestItemsToUnLink.push(r);
            }
          });
          ManifestItems.forEach((r) => {
            if (!linkedManifestItemsSet.has(getIDValue.ManifestItems?.(r))) {
              manifestItemsToLink.push(r);
            }
          });
          manifestItemsToUnLink.forEach((original) => {
            if (!canUnlinkManifestItems) {
              throw Error(
                `ManifestItem ${original.id} cannot be unlinked from Manifest because manifestID is a required field.`
              );
            }
            promises.push(
              client.graphql({
                query: updateManifestItem.replaceAll("__typename", ""),
                variables: {
                  input: {
                    id: original.id,
                    manifestID: null,
                  },
                },
              })
            );
          });
          manifestItemsToLink.forEach((original) => {
            promises.push(
              client.graphql({
                query: updateManifestItem.replaceAll("__typename", ""),
                variables: {
                  input: {
                    id: original.id,
                    manifestID: manifestRecord.id,
                  },
                },
              })
            );
          });
          const modelFieldsToSave = {
            title: modelFields.title ?? null,
            carrierId: modelFields.carrierId,
            adminApproved: modelFields.adminApproved,
            carrierApproved: modelFields.carrierApproved,
            adminComments: modelFields.adminComments ?? null,
            carrierComments: modelFields.carrierComments ?? null,
            manifestDate: modelFields.manifestDate ?? null,
            contentStartDate: modelFields.contentStartDate ?? null,
            contentEndDate: modelFields.contentEndDate ?? null,
            isActive: modelFields.isActive ?? null,
            isManifestDeployed: modelFields.isManifestDeployed ?? null,
            DeploymentDate: modelFields.DeploymentDate ?? null,
            bucket: modelFields.bucket ?? null,
            date: modelFields.date ?? null,
          };
          promises.push(
            client.graphql({
              query: updateManifest.replaceAll("__typename", ""),
              variables: {
                input: {
                  id: manifestRecord.id,
                  ...modelFieldsToSave,
                },
              },
            })
          );
          await Promise.all(promises);
          if (onSuccess) {
            onSuccess(modelFields);
          }
          navigate('/')
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "ManifestUpdateForm")}
      {...rest}
    >
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title: value,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Carrier id"
        isRequired={true}
        isReadOnly={false}
        value={carrierId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              carrierId: value,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.carrierId ?? value;
          }
          if (errors.carrierId?.hasError) {
            runValidationTasks("carrierId", value);
          }
          setCarrierId(value);
        }}
        onBlur={() => runValidationTasks("carrierId", carrierId)}
        errorMessage={errors.carrierId?.errorMessage}
        hasError={errors.carrierId?.hasError}
        {...getOverrideProps(overrides, "carrierId")}
      ></TextField>
      {(storedGroups == 'Admin' && manifestItem) && (<SwitchField

        label="Admin approved"
        defaultChecked={false}
        isDisabled={false}
        isChecked={adminApproved}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved: value,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.adminApproved ?? value;
          }
          if (errors.adminApproved?.hasError) {
            runValidationTasks("adminApproved", value);
          }
          setAdminApproved(value);
        }}
        onBlur={() => runValidationTasks("adminApproved", adminApproved)}
        errorMessage={errors.adminApproved?.errorMessage}
        hasError={errors.adminApproved?.hasError}
        {...getOverrideProps(overrides, "adminApproved")}
      ></SwitchField>)}
      {(storedGroups == 'Carrier' && manifestItem) &&

        <SwitchField
          label="Carrier approved"
          defaultChecked={false}
          isDisabled={false}
          isChecked={carrierApproved}
          onChange={(e) => {
            let value = e.target.checked;
            if (onChange) {
              const modelFields = {
                title,
                carrierId,
                adminApproved,
                carrierApproved: value,
                adminComments,
                carrierComments,
                manifestDate,
                contentStartDate,
                contentEndDate,
                isActive,
                isManifestDeployed,
                DeploymentDate,
                bucket,
                date,
                ManifestItems,
              };
              const result = onChange(modelFields);
              value = result?.carrierApproved ?? value;
            }
            if (errors.carrierApproved?.hasError) {
              runValidationTasks("carrierApproved", value);
            }
            setCarrierApproved(value);
          }}
          onBlur={() => runValidationTasks("carrierApproved", carrierApproved)}
          errorMessage={errors.carrierApproved?.errorMessage}
          hasError={errors.carrierApproved?.hasError}
          {...getOverrideProps(overrides, "carrierApproved")}
        ></SwitchField>}
      {(storedGroups == 'Admin' && manifestItem) && (<TextField
        label="Admin comments"
        isRequired={false}
        isReadOnly={false}
        value={adminComments}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments: value,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.adminComments ?? value;
          }
          if (errors.adminComments?.hasError) {
            runValidationTasks("adminComments", value);
          }
          setAdminComments(value);
        }}
        onBlur={() => runValidationTasks("adminComments", adminComments)}
        errorMessage={errors.adminComments?.errorMessage}
        hasError={errors.adminComments?.hasError}
        {...getOverrideProps(overrides, "adminComments")}
      ></TextField>)}
      {(storedGroups == 'Carrier' && manifestItem) &&
        <TextField
          label="Carrier comments"
          isRequired={false}
          isReadOnly={false}
          value={carrierComments}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                title,
                carrierId,
                adminApproved,
                carrierApproved,
                adminComments,
                carrierComments: value,
                manifestDate,
                contentStartDate,
                contentEndDate,
                isActive,
                isManifestDeployed,
                DeploymentDate,
                bucket,
                date,
                ManifestItems,
              };
              const result = onChange(modelFields);
              value = result?.carrierComments ?? value;
            }
            if (errors.carrierComments?.hasError) {
              runValidationTasks("carrierComments", value);
            }
            setCarrierComments(value);
          }}
          onBlur={() => runValidationTasks("carrierComments", carrierComments)}
          errorMessage={errors.carrierComments?.errorMessage}
          hasError={errors.carrierComments?.hasError}
          {...getOverrideProps(overrides, "carrierComments")}
        ></TextField>}
      <TextField
        label="Manifest date"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={manifestDate && convertToLocal(new Date(manifestDate))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate: value,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.manifestDate ?? value;
          }
          if (errors.manifestDate?.hasError) {
            runValidationTasks("manifestDate", value);
          }
          setManifestDate(value);
        }}
        onBlur={() => runValidationTasks("manifestDate", manifestDate)}
        errorMessage={errors.manifestDate?.errorMessage}
        hasError={errors.manifestDate?.hasError}
        {...getOverrideProps(overrides, "manifestDate")}
      ></TextField>
      <TextField
        label="Content start date"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={contentStartDate && convertToLocal(new Date(contentStartDate))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate: value,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.contentStartDate ?? value;
          }
          if (errors.contentStartDate?.hasError) {
            runValidationTasks("contentStartDate", value);
          }
          setContentStartDate(value);
        }}
        onBlur={() => runValidationTasks("contentStartDate", contentStartDate)}
        errorMessage={errors.contentStartDate?.errorMessage}
        hasError={errors.contentStartDate?.hasError}
        {...getOverrideProps(overrides, "contentStartDate")}
      ></TextField>
      <TextField
        label="Content end date"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={contentEndDate && convertToLocal(new Date(contentEndDate))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate: value,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.contentEndDate ?? value;
          }
          if (errors.contentEndDate?.hasError) {
            runValidationTasks("contentEndDate", value);
          }
          setContentEndDate(value);
        }}
        onBlur={() => runValidationTasks("contentEndDate", contentEndDate)}
        errorMessage={errors.contentEndDate?.errorMessage}
        hasError={errors.contentEndDate?.hasError}
        {...getOverrideProps(overrides, "contentEndDate")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive: value,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <SwitchField
        label="Is manifest deployed"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isManifestDeployed}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed: value,
              DeploymentDate,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.isManifestDeployed ?? value;
          }
          if (errors.isManifestDeployed?.hasError) {
            runValidationTasks("isManifestDeployed", value);
          }
          setIsManifestDeployed(value);
        }}
        onBlur={() =>
          runValidationTasks("isManifestDeployed", isManifestDeployed)
        }
        errorMessage={errors.isManifestDeployed?.errorMessage}
        hasError={errors.isManifestDeployed?.hasError}
        {...getOverrideProps(overrides, "isManifestDeployed")}
      ></SwitchField>
      <TextField
        label="Deployment date"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={DeploymentDate && convertToLocal(new Date(DeploymentDate))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate: value,
              bucket,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.DeploymentDate ?? value;
          }
          if (errors.DeploymentDate?.hasError) {
            runValidationTasks("DeploymentDate", value);
          }
          setDeploymentDate(value);
        }}
        onBlur={() => runValidationTasks("DeploymentDate", DeploymentDate)}
        errorMessage={errors.DeploymentDate?.errorMessage}
        hasError={errors.DeploymentDate?.hasError}
        {...getOverrideProps(overrides, "DeploymentDate")}
      ></TextField>
      <TextField
        label="Bucket"
        isRequired={false}
        isReadOnly={false}
        value={bucket}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket: value,
              date,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.bucket ?? value;
          }
          if (errors.bucket?.hasError) {
            runValidationTasks("bucket", value);
          }
          setBucket(value);
        }}
        onBlur={() => runValidationTasks("bucket", bucket)}
        errorMessage={errors.bucket?.errorMessage}
        hasError={errors.bucket?.hasError}
        {...getOverrideProps(overrides, "bucket")}
      ></TextField>
      <TextField
        label="Date"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={date && convertToLocal(new Date(date))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              title,
              carrierId,
              adminApproved,
              carrierApproved,
              adminComments,
              carrierComments,
              manifestDate,
              contentStartDate,
              contentEndDate,
              isActive,
              isManifestDeployed,
              DeploymentDate,
              bucket,
              date: value,
              ManifestItems,
            };
            const result = onChange(modelFields);
            value = result?.date ?? value;
          }
          if (errors.date?.hasError) {
            runValidationTasks("date", value);
          }
          setDate(value);
        }}
        onBlur={() => runValidationTasks("date", date)}
        errorMessage={errors.date?.errorMessage}
        hasError={errors.date?.hasError}
        {...getOverrideProps(overrides, "date")}
      ></TextField>

      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(userId || manifestModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Cancel"
            type="cancel"
            onClick={() => navigate('/')}
          ></Button>
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(userId || manifestModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
